uniform sampler2D uTrailTexture;
uniform float uTime;
uniform float uDeltaTime;
uniform float uDisplacementStrength;
uniform float uTrailFalloff;
uniform float uAspectRatio;
uniform float uMouseRadius;
uniform float uReturnSpeed;
uniform float uDistortionStrength;

varying vec2 vUv;
varying vec2 vDisplacedUv;
varying float vDistortionStrength;

void main() {
    vUv = uv;

    // Correct UV coordinates for aspect ratio
    vec2 correctedUV = vUv;

    // Sample the trail texture
    vec4 trailData = texture2D(uTrailTexture, correctedUV);

    // Remap the displacement intensity
    float threshold = 0.1;
    float remappedIntensity = 0.0;
    if (trailData.r > threshold) {
        remappedIntensity = (trailData.r - threshold) / (1.0 - threshold);
    }

    // Pass the distortion strength
    vDistortionStrength = remappedIntensity * uDistortionStrength;

    // Apply minimal Z-displacement
    vec3 newPosition = position;
    float maxDisplacement = 0.02; // Prevent occlusion
    newPosition.z += clamp(vDistortionStrength * 0.05, -maxDisplacement, maxDisplacement);

    // Pass displaced UV
    vDisplacedUv = vUv;

    gl_Position = projectionMatrix * modelViewMatrix * vec4(newPosition, 1.0);
}